import { render, staticRenderFns } from "./BusinessInput.vue?vue&type=template&id=26a681f8&"
import script from "./BusinessInput.vue?vue&type=script&lang=js&"
export * from "./BusinessInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports